import * as React from "react"
import * as $ from "jquery"
import {IAdvicePrescription} from "@curefit/care-common";
import { ChangeEvent } from "react" 
import {AppConstants, AppPlaceholders} from "../../utils/AppConstants";
import * as _ from "lodash";
import TypeAhead, { TypeAheadElement, TypeAheadResults} from "../TypeAhead";
import TextAreaAutoResize from "../TextAreaAutoResize";

/**
 * Created by abhinav on 28/01/18.
 */

export interface LifeStyleItemEditorProps {
    consultationType?: string,
    item: IAdvicePrescription;
    onDataChange: (update: any) => any,
    fetchStaticLifeStyleData?: (input: string) => Promise<any>
}

export interface LifeStyleItemEditorState {
    validate: boolean
}

class LifeStyleItemEditor extends React.Component<LifeStyleItemEditorProps, LifeStyleItemEditorState> {
    private lifestyleDOM: any;

    constructor(props: LifeStyleItemEditorProps) {
        super(props)
        this.state = {
            validate: false
        }
    }

    componentDidMount() {
        let myInstance = this;
        $(this.lifestyleDOM).find("input").on("blur", function() {
            setTimeout(function() {
                if ( $(myInstance.lifestyleDOM).find("input:focus").length === 0 ) {
                    myInstance.setState({validate: true})
                }
            }, 100)
        })
    }

    onLifeStyleTypeAheadChange = (input: string) => {
        let typeAheadResults: TypeAheadResults;
        let typeAheadArray: TypeAheadElement[] = [];
        let updatedItem = {...this.props.item, name: input};
        this.props.onDataChange(updatedItem);
        return this.props.fetchStaticLifeStyleData(input).then((results: any[]): Promise<TypeAheadResults> => {
            if (results.length) {
                _.map(results, (lifestyle) => {
                    let typeAheadElement = {
                        value: lifestyle.name,
                        label: lifestyle.displayName
                    }
                    typeAheadArray.push(typeAheadElement);
                })
                typeAheadResults = {options: typeAheadArray, completed: true};
                return Promise.resolve(typeAheadResults);
            } else {
                return Promise.resolve({options: [], completed: false});
            }
        }).catch((error: any) => {
            throw error;
        });
    };

    onLifeStyleTypeAheadSelect = (elem: TypeAheadElement) => {
        let updatedItem = { ...this.props.item, name: elem.label};
        this.props.onDataChange(updatedItem);
    };

    onLifeStyleAdviseChange = (event: ChangeEvent<HTMLInputElement>, meta: any) => {
        let updatedItem = Object.assign({}, this.props.item, {name: event.target.value});
        this.props.onDataChange(updatedItem);
    };

    onLifeStyleInstructionChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        let updatedItem = Object.assign({}, this.props.item, {instruction: event.target.value});
        this.props.onDataChange(updatedItem);
    };

    onMedicationReminderChange = (event: ChangeEvent<HTMLInputElement>) => {
        let updatedItem = { ...this.props.item, remind: event.target.checked }
        this.props.onDataChange(updatedItem);
    }

    render() {
        let lifeStyleName = this.props.item.name !== undefined && this.props.item.name !== null ? this.props.item.name : "";
        let lifeStyleInstruction = this.props.item.instruction !== undefined && this.props.item.instruction !== null ? this.props.item.instruction : "";
        let reminderStatus = this.props.item.remind;
        let lifestyleValidationStatus = this.state.validate && _.isEmpty(this.props.item.name) ? "error" : "";
        return (
            <div className="lifestyle-item-editor" ref={(symptomsDOM) => this.lifestyleDOM = symptomsDOM}>
                <div className={`lifestyle-editor-advise ${lifestyleValidationStatus}`}>
                    <TypeAhead widgetName={"LifeStyleItem"} name="lifestyle-name" value={lifeStyleName || ""} placeholder={AppPlaceholders.LIFESTYLE_ADVICE_EDITVIEW_NAME} onTypeAheadChange={this.onLifeStyleTypeAheadChange} onTypeAheadSelect={this.onLifeStyleTypeAheadSelect}/>
                    {/*<TextInput name="lifestyle-name" value={lifeStyleName} onChange={this.onLifeStyleAdviseChange} placeholder={AppPlaceholders.LIFESTYLE_ADVICE_EDITVIEW_NAME}/>*/}
                </div>
                <div className="lifestyle-editor-instructions">
                    <TextAreaAutoResize
                        name={"lifestyle-editor-instructions"}
                        className={"textarea-input form-control"}
                        value={lifeStyleInstruction}
                        placeholder={AppPlaceholders.LIFESTYLE_ADVICE_EDITVIEW_INSTRUCTIONS}
                        onChange={this.onLifeStyleInstructionChange}
                        rows={2}
                    />
                </div>
                {
                    this.props.consultationType === AppConstants.ConsultationTypes.KMH &&
                    <div className="lifestyle-editor-reminder">
                        <input type="checkbox" onChange={this.onMedicationReminderChange} checked={reminderStatus} />
                    </div>
                }
            </div>
        )
    }
}

export default LifeStyleItemEditor;
